"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "rental",
    path: "/rentals/:id",
    component: "Rental",
    params: [{
            name: "id",
            prop: "rentalId",
        },
    ]
});
let Rental = class Rental extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tabManager;
    async $$load_tabManager() {
        return new this.$app.utils.LazyTabManager();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_rental', { asResource: true, parameters: { id: this.rentalId } });
    }
    messages;
    ux;
    b_7315092382398562_modalBindings;
    b_2285343489561581_to;
    dataMembers = ['tabManager', 'item', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                tabManager: null,
                item: null,
                messages: {
                    delete: this.$fn.pgettext("Rental|Header", "Delete rental"),
                },
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2285343489561581_to: {
                    name: "app.rentals",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.snapshot('name'),
                    this.$fn.gettext("Rental"),
                ],
                icon: this.$config.rental.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4478_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2095089031469157_clickPreventStop(event, scope) {
        return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_9004123373732307_success(event, scope) {
        return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
    }
    async evh_2679161326024595_reload(event, scope) {
        return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
    }
    async evh_7987652045662005_reload(event, scope) {
        return await this.actions.evh_7987652045662005_reload.executeFromDOM(this, event, scope);
    }
    async evh_6490121676898844_reload(event, scope) {
        return await this.actions.evh_6490121676898844_reload.executeFromDOM(this, event, scope);
    }
    async evh_8697745105058001_reload(event, scope) {
        return await this.actions.evh_8697745105058001_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4478 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4478_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4477 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4478,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4477],
        });
        const act_2095089031469157_reloadComponentData_4480 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_2095089031469157_clickPreventStop_4479 = new core_1.actions.EventHandlerImpl({
            action: act_2095089031469157_reloadComponentData_4480,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2095089031469157_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2095089031469157_clickPreventStop_4479],
        });
        const act_9004123373732307_closeComponent_4482 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_9004123373732307_success_4481 = new core_1.actions.EventHandlerImpl({
            action: act_9004123373732307_closeComponent_4482,
            event: "success",
            displayName: "closeComponent",
        });
        const evh_9004123373732307_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_9004123373732307_success_4481],
        });
        const act_2679161326024595_reloadComponentData_4484 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2679161326024595_reload_4483 = new core_1.actions.EventHandlerImpl({
            action: act_2679161326024595_reloadComponentData_4484,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2679161326024595_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2679161326024595_reload_4483],
        });
        const act_7987652045662005_reloadComponentData_4486 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7987652045662005_reload_4485 = new core_1.actions.EventHandlerImpl({
            action: act_7987652045662005_reloadComponentData_4486,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7987652045662005_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7987652045662005_reload_4485],
        });
        const act_6490121676898844_reloadComponentData_4488 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6490121676898844_reload_4487 = new core_1.actions.EventHandlerImpl({
            action: act_6490121676898844_reloadComponentData_4488,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_6490121676898844_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6490121676898844_reload_4487],
        });
        const act_8697745105058001_reloadComponentData_4490 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8697745105058001_reload_4489 = new core_1.actions.EventHandlerImpl({
            action: act_8697745105058001_reloadComponentData_4490,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8697745105058001_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8697745105058001_reload_4489],
        });
        return {
            act_7315092382398562_closeModal_4478,
            evh_7315092382398562_close_4477,
            evh_7315092382398562_close,
            act_2095089031469157_reloadComponentData_4480,
            evh_2095089031469157_clickPreventStop_4479,
            evh_2095089031469157_clickPreventStop,
            act_9004123373732307_closeComponent_4482,
            evh_9004123373732307_success_4481,
            evh_9004123373732307_success,
            act_2679161326024595_reloadComponentData_4484,
            evh_2679161326024595_reload_4483,
            evh_2679161326024595_reload,
            act_7987652045662005_reloadComponentData_4486,
            evh_7987652045662005_reload_4485,
            evh_7987652045662005_reload,
            act_6490121676898844_reloadComponentData_4488,
            evh_6490121676898844_reload_4487,
            evh_6490121676898844_reload,
            act_8697745105058001_reloadComponentData_4490,
            evh_8697745105058001_reload_4489,
            evh_8697745105058001_reload,
            reload: act_2095089031469157_reloadComponentData_4480,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], Rental.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Rental.prototype, "onRental_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Rental.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Rental.prototype, "onSize", null);
Rental = __decorate([
    (0, vue_property_decorator_1.Component)()
], Rental);
exports.default = Rental;
vue_property_decorator_1.Vue.component("Rental", Rental);
